module.exports = __webpack_public_path__ + "img/a57f467b9b54eaf3d2d3bc4f7491c137.9e9578fd.jpg";